<template>
  <el-dialog
    :title="title"
    width="70%"
    :visible.sync="visible"
    :before-close="handleClose"
  >
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label-width="0">
        <el-input
          v-model="form.search"
          placeholder="请输入试卷名称"
          style="
            width: 55%;
            margin-left: 10px;
            margin-right: 10px;
            margin-top: 10px;
          "
        ></el-input>
        <el-button type="primary" style="margin-top: 10px" @click="handleQuery"
          >搜索</el-button
        >
      </el-form-item>
      <el-form-item label-width="0">
        <template>
          <el-table
            ref="multipleTable"
            :data="form.tableData"
            row-key="examsPaperId"
            @selection-change="handleSelectionChange"
            style="width: 100%"
          >
            <el-table-column
              type="selection"
              :reserve-selection="true"
              width="55"
            ></el-table-column>
            <el-table-column prop="examsPaperId" label="试卷ID">
            </el-table-column>
            <el-table-column prop="examsPaperTitle" label="试卷名称">
            </el-table-column>
            <el-table-column prop="moduleTitle" label="板块"> </el-table-column>
            <el-table-column prop="level" label="难度">
              <!--              <template #default="scope">-->
              <!--                <span class="operation" style="color: #606266;" v-if="scope.row.level == '1'" >简单</span>-->
              <!--                <span class="operation" style="color: #606266;" v-if="scope.row.level == '2'" >中等</span>-->
              <!--                <span class="operation" style="color: #606266;" v-if="scope.row.level == '3'" >困难</span>-->
              <!--              </template>-->
            </el-table-column>
            <el-table-column prop="questionsCount" label="试题数">
            </el-table-column>

            <el-table-column prop="score" label="总分"> </el-table-column>
          </el-table>
        </template>
      </el-form-item>
    </el-form>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageObj.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageObj.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      background
      :total="total"
    >
    </el-pagination>
    <span
      slot="footer"
      style="width: 100%; display: inline-block; text-align: center"
    >
      <el-button type="primary" @click="submitForm">确 定</el-button>
      <el-button type="" @click="handleClose">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { http } from '@/utils/axios'
import * as api from '@/api/courseStructure/courseStructure'
export default {
  props: [],
  inject: ['reload'],
  name: 'CourseChooseCourse',
  data() {
    return {
      title: '关联练习/测验',
      multipleSelection: [], // 存放表格选中项信息
      visible: false,
      form: {
        time: 'new Date(2016, 9, 10, 18, 40)',
        choose1: '',
        choose2: '',
        search: '',
        tableData: [],
      },
      courseName: '',
      knowsId: '',
      structureId: '',
      courseWareId: '',
      // 分页
      pageObj: {
        page: 1,
        pageSize: 10,
      },
      // 总数
      total: 0,
      videoType: '',
      content: '',
      id: '',
      paperId: '',
    }
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val
    },

    getList() {
      const { page, pageSize } = this.pageObj
      api
        .getPaperList({
          page,
          pageSize,
          courseWareId: this.courseWareId,
          examsPaperTitle: this.form.search,
        })
        .then(({ data }) => {
          // data = data.data
          this.form.tableData = data.data
          this.total = data.data.length
          // 回显是否选中
          if (
            this.paperId != '' ||
            this.paperId != null ||
            this.paperId != undefined
          ) {
            for (let i = 0; i < this.form.tableData.length; i++) {
              if (this.form.tableData[i].examsPaperId == this.paperId) {
                this.$refs.multipleTable.toggleRowSelection(
                  this.form.tableData[i],
                  true
                )
              }
            }
          }
        })
    },

    // 查询
    handleQuery() {
      this.pageObj.page = 1
      this.getList()
    },

    // 初始化
    init(courseWareId, id, paperId, testStatus) {
      //课件库id  paperId有值为选中，无值为新增  testStatus:1关联测验  2关联考试
      this.visible = true
      this.id = id
      this.paperId = paperId
      this.courseWareId = courseWareId
      this.form.search = ''
      if (testStatus == '1') {
        this.title = '关联练习/测验'
      } else {
        this.title = '关联试卷'
      }
      this.getList()
    },

    // 改变页面接收数据大小
    handleSizeChange(val) {
      this.pageObj.pageSize = val
      this.getList()
    },

    // 改变当前页面
    handleCurrentChange(val) {
      this.pageObj.page = val
      this.getList()
    },

    // 处理弹窗关闭事件
    handleClose(msg) {
      this.visible = false
      this.$refs.multipleTable.clearSelection() //每次关闭页面清空全部勾选
    },

    // 提交
    submitForm() {
      const selectedList = this.$refs.multipleTable.selection
      if (selectedList.length === 0) {
        return this.$message({
          type: 'warning',
          message: '请先选择需要操作的数据',
        })
      } else if (selectedList.length > 1) {
        return this.$message({ type: 'warning', message: '最多可选一个试卷' })
      } else {
        api
          .addCourseStructure({
            zyVideoSectionId: this.id,
            eid: selectedList[0].examsPaperId,
          })
          .then(({ data }) => {
            if (data.code == 100000) {
              this.$message({ type: 'success', message: data.msg })
              this.visible = false
              this.reload()
            } else {
              this.$message({ type: 'error', message: data.msg })
            }
          })
      }
    },
  },
  created() {},
  activated() {
    this.getList()
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
  },
}
</script>

<style lang="scss" scoped>
.content {
  @include flex(center, flex-start);
  .info {
    width: 50%;
    border-right: 1px solid #4e5359;
    &:nth-last-child(1) {
      border-right: none;
    }
    .info-title {
      @include font(18px, #4e5359);
      text-align: center;
      padding-bottom: 20px;
    }
  }
  .el-form {
    .el-form-item {
      margin-left: 40px;
      width: 80%;
    }
  }
}
</style>
<style>
.el-dialog {
  max-height: 80%;
  overflow-y: auto;
}
.chooseCourse {
  margin-right: 10px;
  font-size: 12px;
  line-height: 30px;
}
.courseChoose .courses {
  display: block;
  padding-left: 5%;
  padding-top: 10px;
}
.courseChoose {
  width: 25%;
  float: left;
  border-right: 1px dashed #ccc;
  margin-top: 20px;
  padding-bottom: 10px;
}
.courseChoose:last-child {
  border-right: none;
}
.el-checkbox__label {
  white-space: normal;
  padding-left: 5px;
}
</style>
